import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import NotesSectionHeader from './components/NotesSectionHeader';
import NotesSectionBody from './components/NotesSectionBody';
import { useNotesSection } from './context/NotesSectionContext';

const NotesSection: FC = () => {
  const { data } = useNotesSection();

  return (
    <>
      <div className="mb-5">
        <NotesSectionHeader />
        <NotesSectionBody />
      </div>

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default NotesSection;
